import styled from "styled-components";

export const View = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.gradients.background };

  & > strong:first-of-type {
    margin-top: ${({ theme }) => theme.spacing.xxx_large }px;
    margin-bottom: ${({ theme }) => theme.spacing.xx_medium }px;
  }

  & > strong:last-of-type {
    margin-bottom: ${({ theme }) => theme.spacing.xxx_large }px;
  }

  & > strong {
    min-height: ${({ theme }) => theme.font_size.xxx_medium }px;
    font-size: ${({ theme }) => theme.font_size.xxx_medium }px;
    line-height: ${({ theme }) => theme.font_size.xxx_medium }px;
    font-weight: 900;
    color: ${({ theme }) => theme.colors.text.default };
  }
`;
